import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { RouterProvider } from "react-router-dom";
import routers from "./routing/routers";
import { NextUIProvider } from "@nextui-org/react";
import { Toaster } from "react-hot-toast";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Toaster />
    <NextUIProvider>
      <RouterProvider router={routers}></RouterProvider>
    </NextUIProvider>
  </React.StrictMode>
);

reportWebVitals();
